import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=c6a3e994&scoped=true&"
import script from "./Header.ts?vue&type=script&lang=ts&"
export * from "./Header.ts?vue&type=script&lang=ts&"
import style0 from "./Header.scss?vue&type=style&index=0&id=c6a3e994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a3e994",
  null
  
)

export default component.exports